import { Box } from "@chakra-ui/react";
import BaseLayout from "../../components/base_layout";
import Link from "next/link";
import { useRouter } from "next/router";

export default function SellerExplain() {
  const router = useRouter();

  const moveMarketPlace = async () => {
    router.push("/marketplace/market");
    return;
  };

  return (
    <BaseLayout>
      <Box
        style={{
          width: "100%",
          height: "100%",
          maxWidth: "1100px",
          margin: "0 auto 30px",
        }}
      >
        <Box
          style={{
            width: "1100px",
            height: "500px",
            position: "relative",
            // backgroundColor: "#202e46",
            background: "url(../images/banner/banner_20.png) no-repeat 50% 54%",
            backgroundSize: "cover",
          }}
        >
          <Box
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: "0",
              left: "0",
              background:
                "url(../images/banner/banner_21.png) no-repeat 50% 54%",
              backgroundSize: "contain",
            }}
          ></Box>
        </Box>
        <Box
          style={{
            margin: "3% 0 5%",
          }}
        >
          <h1
            style={{
              fontSize: "36px",
              fontWeight: "500",
              marginBottom: "20px",
              letterSpacing: "-0.5px",
            }}
          >
            판매자를 위한 가이드
          </h1>
          <p style={{ fontSize: "18px" }}>
            * 마켓플레이스는 판매자와 구매자, 모두가 신뢰를 바탕으로 함께
            성장하는 비즈니스 환경을 만들어 갑니다.
          </p>
        </Box>
        <Box
          style={{
            borderTop: "1px solid rgb(20, 24, 31)",
          }}
        >
          <Box
            style={{
              borderBottom: "1px solid rgb(216, 219, 222)",
              padding: "32px 0",
            }}
          >
            <h3 style={{ fontSize: "20px" }}>판매자 등록하기</h3>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * 회원가입 후 마이페이지에서 신청하세요.
            </p>
          </Box>
          <Box
            style={{
              borderBottom: "1px solid rgb(216, 219, 222)",
              padding: "32px 0",
            }}
          >
            <h3 style={{ fontSize: "20px" }}>판매자 인증하기</h3>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * 판매자 등록 신청 후 24시간 내 인증이 완료합니다.
            </p>
          </Box>
          <Box
            style={{
              borderBottom: "1px solid rgb(216, 219, 222)",
              padding: "32px 0",
            }}
          >
            <h3 style={{ fontSize: "20px" }}>재고 데이터 등록하기</h3>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * 판매자 대시보드에서 재고 데이터를 등록해 주세요.
            </p>
          </Box>
          <Box
            style={{
              borderBottom: "1px solid rgb(216, 219, 222)",
              padding: "32px 0",
            }}
          >
            <h3 style={{ fontSize: "20px" }}>재고 데이터 인증하기</h3>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * 재고 데이터 등록 신청 후 24시간 내 인증이 완료됩니다.
            </p>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * 인증이 완료된 재고 데이터는 마켓플레이스에서 서비스됩니다.
            </p>
          </Box>
          <Box
            style={{
              padding: "32px 0",
            }}
          >
            <h3 style={{ fontSize: "20px" }}>판매자 대시보드 견적하기</h3>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * 구매자의 RFQ에 알림을 받은 후 견적정보를 입력하세요.
            </p>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * 견적 회신하기를 클릭해 주세요.
            </p>
          </Box>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              moveMarketPlace();
            }}
            style={{
              textAlign: "center",
            }}
            className="goto_marketplacestore"
          >
            탐색하기
          </a>
        </Box>
      </Box>
    </BaseLayout>
  );
}
